import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Autosuggest from 'react-autosuggest';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';

const transitionProperties = ' 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms';

const placeholderStyles = {
	fontStyle: 'italic',
	opacity: '0.42',
	transition: `opacity ${transitionProperties}`
};

const styles = theme => ({
	autosuggestInput: {
		...theme.overrides.MuiInput.input,
		...theme.overrides.MuiInput.root,
		outline: 'none',
		'&::-webkit-input-placeholder': placeholderStyles,
		'&::-moz-placeholder': placeholderStyles,
		'&:-ms-input-placeholder': placeholderStyles,
		'&::-ms-input-placeholder': placeholderStyles,
		fontSize: 14,
		transition: `border-radius ${transitionProperties}`
	},
	autosuggestInputOpen: {
		borderBottomRightRadius: 0,
		borderBottomLeftRadius: 0,
		transition: `border-radius ${transitionProperties}`
	},
	autosuggestContainer: {
		position: 'relative',
		width: 240,
		marginBottom: 5
	},
	autosuggestSuggestionsContainer: {
		opacity: 0,
		transition: `opacity ${transitionProperties}`
	},
	autosuggestSuggestionsContainerOpen: {
		position: 'absolute',
		marginTop: 0,
		borderRadius: '0px 0px 20px 20px',
		zIndex: 1,
		left: 1,
		right: 1,
		overflow: 'hidden',
		opacity: 1,
		transition: `opacity ${transitionProperties}`
	},
	autosuggestSuggestionHighlighted: {
		backgroundColor: 'rgba(0, 0, 0, 0.08)'
	},
	autosuggestSuggestion: {
		display: 'block'
	},
	menuItem: {
		fontSize: 14,
		paddingTop: 6,
		paddingBottom: 6,
	},
	autosuggestSuggestionsList: {
		margin: 0,
		padding: '5px 0',
		listStyleType: 'none',
		maxHeight: 200,
		overflowY: 'auto'
	},
	disabled: {}
});

@withStyles(styles)
class AutoComplete extends Component {

	constructor(props) {
		super();
		this.state = {
			suggestions: []
		};
	}

	getSuggestions = value => {
		const inputValue = value.trim().toLowerCase();
		const inputLength = inputValue.length;
		return inputLength === 0 ? [] : this.props.suggestions.filter(option =>
			option.toLowerCase().indexOf(inputValue) === 0
		);
	};

	onSuggestionsFetchRequested = ({ value }) => {
		this.setState({
			suggestions: this.getSuggestions(value)
		});
	};

	onSuggestionsClearRequested = () => {
		this.setState({
			suggestions: []
		});
	};

	getSuggestionValue = (suggestion) => {
		return suggestion;
	}

	renderSuggestionsContainer = (options) => {
		return (<Paper {...options.containerProps}>
			{options.children}
		</Paper>);
	}

	renderSuggestion = (suggestion, { query, isHighlighted }) => {
		let { classes } = this.props;
		return <MenuItem className={classes.menuItem} selected={isHighlighted} component="div">{suggestion}</MenuItem>;
	}

	render() {
		const { classes, inputProps } = this.props;

		inputProps.autoComplete = 'new-password';
		inputProps.spellCheck = 'false';

		return (<Autosuggest
			theme={{
				input: classes.autosuggestInput,
				inputOpen: classes.autosuggestInputOpen,
				container: classes.autosuggestContainer,
				suggestionsContainer: classes.autosuggestSuggestionsContainer,
				suggestionsContainerOpen: classes.autosuggestSuggestionsContainerOpen,
				suggestionsList: classes.autosuggestSuggestionsList,
				suggestion: classes.autosuggestSuggestion,
				suggestionHighlighted: classes.autosuggestSuggestionHighlighted
			}}
			inputProps={inputProps}
			suggestions={this.state.suggestions}
			onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
			onSuggestionsClearRequested={this.onSuggestionsClearRequested}
			getSuggestionValue={this.getSuggestionValue}
			renderSuggestion={this.renderSuggestion}
			renderSuggestionsContainer={this.renderSuggestionsContainer}
		/>);
	}
}

AutoComplete.propTypes = {
	suggestions: PropTypes.array.isRequired,
	classes: PropTypes.object,
	inputProps: PropTypes.object
};

export default AutoComplete;



// WEBPACK FOOTER //
// ./src/components/AutoComplete/index.js